import { render, staticRenderFns } from "./CertificateFilter.vue?vue&type=template&id=2c0622c7&scoped=true&"
import script from "./CertificateFilter.vue?vue&type=script&lang=js&"
export * from "./CertificateFilter.vue?vue&type=script&lang=js&"
import style0 from "./CertificateFilter.vue?vue&type=style&index=0&id=2c0622c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0622c7",
  null
  
)

export default component.exports